import { FC } from 'react';

export interface ICacTabItem {
  key: string;
  label: string;
}

interface IProps {
  tabs: ICacTabItem[];
  activeKey: string;
  onChange: (key: string) => void;
}

/** 종합 / 소계 / 캠퍼스 필터 — `.comm-tab__button` pill 스타일 */
const CacReportTabs: FC<IProps> = ({ tabs, activeKey, onChange }) => {
  return (
    <div className="comm-tab__button mb-3">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`btn-basic gray-line ${activeKey === tab.key ? 'active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default CacReportTabs;
